/**
 * Ronin icon SVG component
 * https://skymavis.notion.site/Ronin-Network-dd6cf4f22c884957aacc64bfb829a6c8
 */
export function RoninIcon({ className }: { className?: string }) {
  return (
    <svg
      width="214"
      height="300"
      viewBox="0 0 214 300"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 23.0778V208.161C0.00216569 211.618 0.782904 215.031 2.28454 218.146C3.78617 221.262 5.97033 224.001 8.67568 226.162L96.1554 296.203C99.2329 298.661 103.058 300 107 300C110.942 300 114.767 298.661 117.845 296.203L205.324 226.162C208.03 224.001 210.214 221.262 211.715 218.146C213.217 215.031 213.998 211.618 214 208.161V23.0778C214 16.9572 211.563 11.0872 207.224 6.75932C202.885 2.4314 197.001 0 190.865 0H23.1351C16.9993 0 11.1148 2.4314 6.77612 6.75932C2.43744 11.0872 0 16.9572 0 23.0778Z"
        fill="#004DE5"
      />
      <path
        d="M168.963 106.654V66.2179C168.963 60.8558 166.873 55.7133 163.154 51.9217C159.434 48.1301 154.389 46 149.129 46H64.834C59.5737 46 54.5289 48.1301 50.8093 51.9217C47.0897 55.7133 45 60.8558 45 66.2179V183.545C45.0019 186.573 45.6712 189.563 46.9586 192.292C48.2459 195.022 50.1184 197.422 52.4378 199.315L83.131 224.435C83.4953 224.737 83.9361 224.926 84.402 224.983C84.8679 225.039 85.3399 224.959 85.7631 224.752C86.1863 224.546 86.5433 224.221 86.7928 223.816C87.0422 223.411 87.1737 222.942 87.1721 222.464V139.508C87.1721 138.837 87.4334 138.195 87.8983 137.721C88.3633 137.247 88.9939 136.98 89.6514 136.98H111.965C115.91 136.98 119.694 138.578 122.483 141.422C125.273 144.265 126.84 148.122 126.84 152.144V222.464C126.841 222.94 126.973 223.406 127.222 223.809C127.47 224.212 127.826 224.535 128.247 224.741C128.668 224.947 129.137 225.028 129.601 224.973C130.065 224.919 130.505 224.733 130.869 224.435L161.562 199.315C163.882 197.422 165.754 195.022 167.041 192.292C168.329 189.563 168.998 186.573 169 183.545V147.089C169 141.727 166.91 136.585 163.191 132.793C159.471 129.002 154.426 126.871 149.166 126.871C154.42 126.861 159.455 124.727 163.167 120.936C166.878 117.146 168.963 112.009 168.963 106.654ZM111.94 116.763H89.6266C88.9691 116.763 88.3385 116.496 87.8735 116.022C87.4086 115.548 87.1474 114.906 87.1474 114.235V68.7451C87.1474 68.0748 87.4086 67.432 87.8735 66.9581C88.3385 66.4841 88.9691 66.2179 89.6266 66.2179H124.336C124.994 66.2179 125.624 66.4841 126.089 66.9581C126.554 67.432 126.815 68.0748 126.815 68.7451V101.599C126.815 105.621 125.248 109.478 122.459 112.321C119.669 115.165 115.885 116.763 111.94 116.763Z"
        fill="url(#paint0_linear_1919_16)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1919_16"
          x1="107"
          y1="46"
          x2="107"
          y2="225"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="0.458333" stop-color="white" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
      </defs>
    </svg>
  );
}
